import { Theme } from "common";

export const traineeFilterStyles = {
  formControlLabel: {
    marginLeft: "5px",
  },
  formControlLabelRoot: {
    marginLeft: "0px",
    "&&": {
      "& .MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1": {
        color: Theme.palette.grey[700],
      },
    },
  },
  checkBoxWrapper: {
    marginBottom: "15px",
  },
  filterWrapper: {
    marginRight: "7px",
  },
  inputBaseRoot: {
    paddingRight: "5px",
  },
  inputBaseInput: {
    paddingLeft: "5px",
  },
  fieldTextStyle: {
    margin: "inherit",
    color: Theme.palette.grey[700],
  },
  datePickerFormControl: {
    display: "flex",
    width: "100%",
    "&&": {
      "& .MuiFormControl-root": {
        marginTop: "5px",
        marginBottom: "5px",
      },
    },
  },
  dateSeparator: {
    margin: "14px 5px",
  },
  checkBoxRoot: {
    border: Theme.palette.grey[500],
    backgroundColor: Theme.palette.common.white,
    "& .MuiSvgIcon-root": {
      fill: "gray",
      backgroundColor: Theme.palette.common.white,
      border: Theme.palette.grey[500],
    },
  },
};
